module.exports = __webpack_public_path__ + "Frutiger-Cn.woff2?655b5aad96efd17f57121c9b38971c76";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Frutiger-Cn.woff2
// module id = 44
// module chunks = 0